// @copyright  2006 - 2024 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'team-member-reporting-role.page.title': 'Reporting Roles',
    'team-member-reporting-role.page.search_results': 'Search Results',
    'team-member-reporting-role.page.create.title': 'Create New Role',
    'team-member-reporting-role.page.search.title': 'Find Roles',
    'team-member-reporting-role.page.edit.title': 'Edit Role',
    'team-member-reporting-role.page.view.title': 'View Role',
    'team-member-reporting-role.page.all': 'All',

    'team-member-reporting-role.button.cancel': 'Cancel',
    'team-member-reporting-role.button.select': 'Select',
    'team-member-reporting-role.button.find': 'Find Roles',
    'team-member-reporting-role.button.search': 'Apply',
    'team-member-reporting-role.button.create': 'Create Role',
    'team-member-reporting-role.button.new': 'New Role',
    'team-member-reporting-role.button.save': 'Save Changes',
    'team-member-reporting-role.button.delete': 'Permanently Delete',
    'team-member-reporting-role.button.edit': 'Edit',
    'team-member-reporting-role.button.restore': 'Restore',
    'team-member-reporting-role.button.reset': 'Reset',

    'team-member-reporting-role.placeholder.search': 'Search roles',

    'team-member-reporting-role.link.create_first_team_member_reporting_role': 'Click here to create your first role',
    'team-member-reporting-role.link.team_member_reporting_roles': ' Return to Roles',
    'team-member-reporting-role.link.retry': 'Click here to retry',

    'team-member-reporting-role.checkbox.all': 'Check All',
    'team-member-reporting-role.checkbox.actions_label': 'with selected',

    'team-member-reporting-role.label.team_member_reporting_role_name': 'Role Name',
    'team-member-reporting-role.label.parent_team_member_reporting_role_name': 'Reports To',
    'team-member-reporting-role.label.owner_team_member_name': 'Owner Team Member',
    'team-member-reporting-role.label.acting_as_team_member_name': 'Acting As Team Member',

    'team-member-reporting-role.sort.field_label': 'Field',
    'team-member-reporting-role.sort.direction_label': 'Direction',
    'team-member-reporting-role.sort.direction_ascending': 'Ascending',
    'team-member-reporting-role.sort.direction_descending': 'Descending',

    'team-member-reporting-role.modal.title.team_member_reporting_role_delete_permanently': 'Delete Role',
    'team-member-reporting-role.modal.title.team_member_reporting_role_restore': 'Restore Role',

    'team-member-reporting-role.modal.message.team_member_reporting_role_delete_permanently':
        'Are you sure that you want to permanently delete this role? This action cannot be undone. | Are you sure that you want to permanently delete these roles? This action cannot be undone.',
    'team-member-reporting-role.modal.message.team_member_reporting_role_restore': 'Are you sure that you want to restore this role? | Are you sure that you want to restore these roles?',

    'team-member-reporting-role.success.message.team_member_reporting_role_created': 'Your role has been created',
    'team-member-reporting-role.success.message.team_member_reporting_role_updated': 'Your role has been updated',
    'team-member-reporting-role.success.message.team_member_reporting_role_restored': 'Your role has been restored | All selected roles were restored',
    'team-member-reporting-role.success.message.team_member_reporting_role_deleted': 'Your role has been permanently deleted | All selected roles were permanently deleted',

    'team-member-reporting-role.error.message.team_member_reporting_role_deleted': 'This role was already permanently deleted | These roles were already permanently deleted',
    'team-member-reporting-role.error.message.team_member_reporting_role_restored': 'This role was already restored | These roles were already restored',
    'team-member-reporting-role.error.message.error_loading_page': 'Sorry, there was an error loading role.| Sorry, there was an error loading roles.',
};
